import React, { Component } from 'react';
import { Form } from 'react-bootstrap';

class StampingServiceAgreement extends Component {

  state= {}

  constructor(props) {
    super(props);

    this.state = {
      terms_accepted: false
    };
  }

  handleOnChange = (event) => {
    const { name, checked } = event.target;

    this.setState({
      [name]: checked
    });

    this.props.onTermsAcceptanceChange(checked);
  }

  render() {
    const { terms_accepted } = this.state;
    const { showAcceptTermsCheckbox = true } = this.props;

    return (
      <div className="manifiesto-agreement mt-3">
        <p>
          De acuerdo con lo dispuesto en la regla 2.7.2.7. de la Resolución Miscelánea Fiscal para 2019 publicada en el Diario Oficial de la Federación el 29 de abril de 2019:
        </p>

        <p>
          &nbsp;&nbsp;Toda vez que haré uso de los servicios de un Proveedor Autorizado de Certificación de Comprobantes Fiscales Digitales por Internet, seleccionado por mi o asignado automáticamente, manifiesto mi conocimiento y autorización para que la validación de comprobantes fiscales digitales a través de internet (CFDI) sean entregados al Servicio de Administración Tributaria (SAT) a través de copia de los comprobantes fiscales que me hayan validado en dicho servicio.
        </p>

        <p>
          &nbsp;&nbsp;Al mismo tiempo acepto que quien brinde a mi nombre o a mi representación el servicio de certificación, validacion y timbrado de los Comprobantes Fiscales Digitales por Internet (CFDI), emita mis comprobantes como persona física o como persona moral.
        </p>

        { !!showAcceptTermsCheckbox && (
            <Form.Group controlId="terms_accepted">
              <Form.Check type="checkbox"
                name="terms_accepted"
                label="Manifiesto mi consentimiento"
                checked={ terms_accepted || false }
                onChange={ this.handleOnChange }
              />
            </Form.Group>
          )
        }
      </div>
    )
  }

}

export default StampingServiceAgreement;